import React from "react"
import { Drawer } from "material-ui"
import AccountManagerClientTabDrawerNewAccount from "./AccountManagerClientTabDrawerNewAccount"
import AccountManagerClientTabDrawerEditAccount from "./AccountManagerClientTabDrawerEditAccount"

interface IProps {
    accountId: string
    editDrawer: boolean
    drawerOpen: boolean
    closeDrawer(): void
    reloadData(): void
}

const AccountManagerClientTabDrawer: React.SFC<IProps> = (props: IProps) => {
    return (
        <Drawer
            open={props.drawerOpen}
            openSecondary
            docked={false}
            width={1050}
            style={{ maxWidth: 1050, zIndex: 999 }}
            containerStyle={{ overflow: "unset" }}
            onRequestChange={props.closeDrawer}
        >
            {props.drawerOpen &&
                <div>
                    {props.editDrawer &&
                        <AccountManagerClientTabDrawerEditAccount
                            accountId={props.accountId}
                            reloadData={props.reloadData}
                            closeDrawer={props.closeDrawer}
                        />
                    }
                    {!props.editDrawer &&
                        <AccountManagerClientTabDrawerNewAccount closeDrawer={props.closeDrawer} reloadData={props.reloadData} />
                    }
                </div>
            }
        </Drawer>
    )
}

export default AccountManagerClientTabDrawer